import { RowExportTypePdf } from "types";
import { PdfTemplate } from "components";
import { ListBrand } from "../types";

export function PdfBrand(props: { dataList: ListBrand[] }) {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "CODE", key: "code", width: 10 },
    { header: "GROUP ASSET", key: "group_asset", width: 10 },
    { header: "BRAND", key: "brand", width: 10 },
    { header: "DESCRIPTION", key: "description", width: 15 },
  ];

  const dataMap: RowExportTypePdf[] = props.dataList.map((item, index) => ({
    no: index + 1,
    code: item.mr_brand_code ?? "-",
    group_asset: item.mr_group_name ?? "-",
    brand: item.mr_brand_name ?? "-",
    description: item.description ?? "-",
  }));

  return <PdfTemplate data={dataMap} column={columns} title="Brand" />;
}
